import { SystemRole } from '../Enums/system-role.enum';
import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

export const ROLE_OPS_RETRY = SystemRole.BACKOFFICE_ADMIN;

export const ROLE_WEBHOOK_REPLAY = SystemRole.BACKOFFICE_BILLING_ADMIN;

export const HEALTH_LABEL: Readonly<Record<string, string>> = {
  green: 'backoffice.enums.ops_health.green',
  amber: 'backoffice.enums.ops_health.amber',
  red: 'backoffice.enums.ops_health.red',
  unknown: 'backoffice.enums.ops_health.unknown',
};

export const HEALTH_TONE: Readonly<Record<string, StatusTone>> = {
  green: 'positive',
  amber: 'warning',
  red: 'danger',
  unknown: 'neutral',
};

export const COMMAND_CADENCE: Readonly<Record<string, string>> = {
  'devices:reap-inactive': 'backoffice.enums.command_cadence.devices:reap-inactive',
  'directory:reconcile': 'backoffice.enums.command_cadence.directory:reconcile',
  'overrides:revert-expired': 'backoffice.enums.command_cadence.overrides:revert-expired',
  'billing:dunning': 'backoffice.enums.command_cadence.billing:dunning',
  'billing:reconcile': 'backoffice.enums.command_cadence.billing:reconcile',
  'tenant:health-check': 'backoffice.enums.command_cadence.tenant:health-check',
  'ops:health-check': 'backoffice.enums.command_cadence.ops:health-check',
};

export const RETRY_ONE_TITLE = 'backoffice.ops.failed_jobs.retry_one_title';

export const RETRY_ALL_TITLE = 'backoffice.ops.failed_jobs.retry_all_title';

export const RETRY_CONSEQUENCE = 'backoffice.ops.failed_jobs.retry_consequence';

export const RETRY_CONFIRM_LABEL = 'backoffice.ops.failed_jobs.retry_confirm';

export const RETRY_APPLIED_MESSAGE = 'backoffice.ops.failed_jobs.retried';

export const RETRY_ALL_APPLIED_MESSAGE = 'backoffice.ops.failed_jobs.retried_all';

export const WEBHOOK_REPLAY_TITLE = 'backoffice.ops.webhooks.replay_title';

export const WEBHOOK_REPLAY_CONSEQUENCE = 'backoffice.ops.webhooks.replay_consequence';

export const WEBHOOK_REPLAYED_MESSAGE = 'backoffice.ops.webhooks.replayed';

export const AUDIT_SYSTEM_ACTOR = 'backoffice.ops.audit.system_actor';
